/**
 * Un événement Yousign d'une demande de signature du contrat, tel que le webhook l'a reçu. Le sujet
 * est l'embauche, à l'identifiant du contrat, ou un avenant, au sien.
 */
export interface YousignEvent {
  event: string;
  at: string;
  subjectId: string;
}

/**
 * Un envoi en signature échoué du contrat (RG-signature-echec-visible) : la marque ne garde que le
 * dernier, le journal les garde tous. Le sujet est l'embauche ou un avenant, comme ci-dessus.
 */
export interface SignatureSendFailure {
  subjectId: string;
  failedAt: string;
  /** Le nom de qui a lancé l'envoi, figé au moment de l'échec. */
  failedBy: string;
  reason: string;
}

export interface SignatureRequest {
  signatureRequestId: string; // UUID
  status: SignatureRequestStatus;
  employeeSignerUserId: string; // UUID
  createdAt: string; // ISO 8601 (ZonedDateTime)
  activatedAt?: string | null;
  signedAt?: string | null;
  expiresAt?: string | null;
}

export const signatureRequestStatusValues = [
  'draft',
  'ongoing',
  'done',
  'deleted',
  'expired',
  'canceled',
  'approval',
  'rejected',
  'declined',
  'paused',
] as const;
export type SignatureRequestStatus = (typeof signatureRequestStatusValues)[number];

function getExpiresAtTime(value?: string | null): number {
  if (!value) return Number.NEGATIVE_INFINITY;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time;
}

export function getLatestSignatureRequest(
  requests?: SignatureRequest[],
): SignatureRequest | undefined {
  if (!requests?.length) return undefined;
  return requests.reduce((latest, current) =>
    new Date(current.createdAt).getTime() > new Date(latest.createdAt).getTime() ? current : latest,
  );
}
